import React from 'react';
import {
  TextList as LegacyTextList,
  TextListItem as LegacyTextListItem,
  TextListProps,
  TextListItemProps,
} from './TextList.legacy';
import { TextList as AlphaTextList, TextListItem as AlphaTextListItem } from './TextList.alpha';

export const TextList = (
  process.env.IS_LEGACY ? LegacyTextList : AlphaTextList
) as React.FC<TextListProps>;
export const TextListItem = (
  process.env.IS_LEGACY ? LegacyTextListItem : AlphaTextListItem
) as React.FC<TextListItemProps>;

export type { TextListProps, TextListItemProps };
